import React from "react";
import { FiX } from "react-icons/fi";
import "./ConfirmModal.css";

const ConfirmModal = ({
  open,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  confirmType = "danger", // "danger" | "primary"
}) => {
  if (!open) return null;

  return (
    <div className="confirm-overlay">
      <div className="confirm-modal">
        <FiX className="confirm-close" onClick={onCancel} />

        <h3>{title}</h3>
        <p>{message}</p>

        <div className="confirm-actions">
          <button className="confirm-cancel-btn" onClick={onCancel}>
            {cancelText}
          </button>

          <button
            className={
              confirmType === "danger"
                ? "confirm-danger-btn"
                : "confirm-primary-btn"
            }
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
